var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.57158 2.53576L9.51485 2.47837C8.58081 1.53341 7.31149 1.00039 5.98549 1.00039C4.65948 1.00039 3.39016 1.53341 2.45612 2.47837C1.52247 3.42294 1 4.7016 1 6.03246C1 7.36332 1.52247 8.64199 2.45612 9.58655L3.22405 10.3635L8.86038 16.0657C9.04824 16.2557 9.30435 16.3627 9.57158 16.3627C9.83881 16.3627 10.0949 16.2557 10.2828 16.0657L15.9191 10.3635L16.6869 9.58672C16.6869 9.5867 16.6869 9.58669 16.6869 9.58667C16.687 9.58663 16.687 9.58659 16.687 9.58655C17.1495 9.11885 17.5158 8.56419 17.7655 7.95455C18.0152 7.34486 18.1436 6.69176 18.1436 6.03246C18.1436 5.37317 18.0152 4.72007 17.7655 4.11037C17.5158 3.5008 17.1496 2.9462 16.6872 2.47854C16.2249 2.01056 15.6753 1.63871 15.0695 1.38478C14.4638 1.13085 13.8141 1 13.1577 1C12.5013 1 11.8516 1.13085 11.2458 1.38478L11.6235 2.28567L11.2458 1.38479C10.6402 1.63868 10.0906 2.01047 9.62831 2.47837C9.62826 2.47843 9.6282 2.47848 9.62815 2.47854L9.57158 2.53576Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like_icon.47c30e15e80e99229373aa3d5903e1fc.svg";
export { ForwardRef as ReactComponent };